import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Message } from "semantic-ui-react";
import { GetUser } from "../Utils/UserAPI";
import { LoginInfo } from "../Utils/Login";

interface OwnAddressWarningProps {
    loginInfo: LoginInfo;
}

export default function OwnAddressWarning({ loginInfo }: OwnAddressWarningProps) {
    const [missingAddress, setMissingAddress] = useState(false);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (!loginInfo.id) {
            return;
        }

        let cancelled = false;

        GetUser(loginInfo.id, (statusCode, user) => {
            if (!cancelled && statusCode === 200 && user) {
                setMissingAddress(user.missing_address);
            }
            if (!cancelled) {
                setLoaded(true);
            }
        });

        return () => {
            cancelled = true;
        };
    }, [loginInfo.id]);

    if (!loaded || !missingAddress) {
        return null;
    }

    return (
        <Message negative>
            <p>
                We don't have a valid mailing address on file for you. Please{" "}
                <Link to="/myaccount">update your account</Link> with your current mailing address.
            </p>
        </Message>
    );
}
